// Session replay starts after the page load, outside the first-render workload.
// Conversion tags remain in their existing integrations.
(function () {
  const source = 'https://t.contentsquare.net/uxa/9509325253d52.js';
  function loadReplay() {
    if (document.querySelector('script[src="' + source + '"]')) return;
    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    document.head.appendChild(script);
  }
  function scheduleReplay() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadReplay, { timeout: 2000 });
    } else {
      window.setTimeout(loadReplay, 0);
    }
  }
  if (document.readyState === 'complete') scheduleReplay();
  else window.addEventListener('load', scheduleReplay, { once: true });
})();
